var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 90 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53357 40.3742L1.31584 39.0821L1 38.6044V37.5464H24.8514L25.1399 1H45.6251V16.8208L47.5486 18.3596L49.5683 17.8306L50.9148 19.5618L55.8678 21.0525L57.6951 20.3792L59.7628 22.5912L61.0131 21.5333L63.0328 22.8798L64.0426 22.1585L64.7159 23.8415L65.918 21.918L66.976 22.8798L67.9377 22.1585L69.9093 23.8415L72.6503 22.5912L73.5159 22.8798L74.3814 22.1585L76.6415 22.5912L77.7475 21.918L83.6623 25.1399L85.5377 24.7552V37.5464L86.4033 38.3639L86.9323 40.047L89 44.9519L87.7497 48.6546V52.4535L86.4033 54.4251L86.9323 55.5311L82.8929 56.3967L81.0175 58.1279L79.9115 59.1858L79.4787 58.753L78.2284 59.1858V60.388L72.6503 63.6098L71.1596 64.1869V63.2732H69.9093L67.6973 62.7923L69.4765 65.1486L68.4667 65.7738L66.976 65.4852V67.1683L66.447 66.6393L63.9945 67.7454L65.6295 68.0339L64.5235 69.3803L62.7443 69.1399L63.9945 71.4962L62.7443 73.1311V75.0066L62.1191 76.1126V77.4109L63.6098 82.412L64.9082 83.9508L62.7443 84.7202L61.6383 83.518L54.8579 81.9311L51.7803 80.5366L48.9913 73.9967L48.6066 71.4962L47.3082 70.9672L46.5869 69.3803L43.7978 66.6393L41.2011 60.388L37.9312 57.2623L36.1038 54.8098L30.5738 54.0404L28.4098 54.8098L24.2262 61.0612L15.1858 56.1082L12.6372 48.6546L4.36612 42.0186L3.53357 40.3742Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTx);
export default __webpack_public_path__ + "static/media/TX.0f4b57a4f0e6a23ff59b22299c72ad4f.svg";
export { ForwardRef as ReactComponent };